import {axios, API, SendRequest} from '@/imports-files/pages/interviews/cronofy';

export class Cronofy extends SendRequest {
  async getCronofyHash(token, hostName) 
  {
    try {
      const result = await axios.get( API.client.cronofy.GET_CRONOFY_HASH,
          {
            params: {token: token},
            headers: this.serverSideHeaderJSON(hostName)
          },
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async getMoreDaysSlots(data) 
  {
    try {
      const result = await axios.get( API.client.cronofy.GET_MORE_DAYS_SLOTS,
          {
            params: data,
            headers: this.customHeaderJSON()
          },
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async interviewBooked(params) 
  {
    try {
      const result = await axios.post( API.client.cronofy.BOOK_INTERVIEW,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
  async requestForSlots(params, type) 
  {
    // const url = type == 'reschedule_request' ? API.client.cronofy.RESCHEDULE_REQUEST : API.client.cronofy.REQUEST_FOR_SLOTS
    try {
      const result = await axios.post(API.client.cronofy.REQUEST_FOR_SLOTS,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async rescheduleRequest(params){
    try {
      const result = await axios.post(API.client.cronofy.RESCHEDULE_REQUEST,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async cancelInterview(params) 
  {
    try {
      const result = await axios.post( API.client.cronofy.CANCEL_INTERVIEW,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async updateContactNo(params){
    try {
      const result = await axios.post( API.client.cronofy.UPDATE_CONTACT_NO,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
}